export default __webpack_public_path__ + "assets/clip-a575989843a38c113c62d83022caebcc.svg";